module.exports = __webpack_public_path__ + "static/media/Ally Huddleston.c0a0925b.png";